import axios from "axios";
import jwtDecode from "jwt-decode";
import authUrls from "utils/urls/authUrls";

const refreshToken = async () => {
  const token = localStorage.getItem("refresh");
  const data = new FormData();
  data.append("refresh", token);
  const response = axios.post(authUrls.refreshToken(), data);
  return response;
};

const loginUser = async (username, password) => {
  const result = await axios
    .post(authUrls.login(), {
      email: username,
      password,
    })
    .then((response) => {
      const tokenData = jwtDecode(response?.data?.access);
      if (tokenData?.type !== "SYS_ADMIN") {
        alert("Only System Admin has access to Admin App");
        return false;
      }
      if (response.data.access !== undefined) {
        localStorage.setItem("token", response.data.access);
        localStorage.setItem("refresh", response.data.refresh);
        return true;
      }
      return false;
    })
    .catch(() => {
      return false;
    });
  return result;
};

const resetUserPassword = async (email) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.post(
    authUrls.resetPassword(),
    { email },
    {
      headers: headersInternal,
    }
  );
};

const updatePasswordApi = async (password, apiToken) => {
  const data = new FormData();
  data.append("password", password);
  data.append("update_token", apiToken);
  const result = await axios.post(authUrls.updatePassword(), data);
  if (result.status === 200) {
    return true;
  }
  return false;
};

const updateProfile = async (
  password,
  phone,
  firstName,
  lastName,
  title,
  photoUpload,
  userId
) => {
  const data = new FormData();
  data.append("title", title);
  data.append("first_name", firstName);
  data.append("last_name", lastName);
  data.append("phone", phone);
  data.append("profile_pic", photoUpload);
  data.append("password", password);
  data.append("id", userId);
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const response = await axios.post(authUrls.updateProfile(), data, {
    headers: headersInternal,
  });
  if (response.status === 200) {
    return true;
  }
  return false;
};

const getProfileData = async (id) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(authUrls.getProfileData(), {
    params: { id },
    headers: headersInternal,
  });
  return res;
};

const addNewUser = async ({
  email,
  first_name,
  last_name,
  username,
  userImage,
  organizationId,
}) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "multipart/form-data",
  };

  const formData = new FormData();
  formData.append("user.username", username);
  formData.append("user.email", email);
  formData.append("user.first_name", first_name);
  formData.append("user.last_name", last_name);
  formData.append("user.type", "ORG_ADMIN");
  formData.append("user.is_active", "1");
  formData.append("userprofile.organization", organizationId);
  formData.append("userprofile.profile_pic", userImage);
  formData.append("userprofile.roles", 1);
  formData.append("userprofile.roles", 2);
  formData.append("userprofile.roles", 3);

  const res = await axios.post(authUrls.getUsersUrl(), formData, {
    headers: headersInternal,
  });

  return res;
};

const getAlphabeticalUser = async (sort_by) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(authUrls.getUsersOrganizationsUrl(), {
    params: {
      type: "alpha",
      ordering: `${sort_by ? "-title" : "title"}`,
    },
    headers: headersInternal,
  });
  return res;
};

const getNumericUser = async (sort_by) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  const res = await axios.get(authUrls.getUsersOrganizationsUrl(), {
    params: {
      type: "numeric",
      ordering: `${sort_by ? "-title" : "title"}`,
    },
    headers: headersInternal,
  });
  return res;
};

const deleteUser = (id) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.delete(authUrls.getUsersUrl(id), {
    headers: headersInternal,
  });
};

const lockUser = async (userId, lockValue) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.patch(
    authUrls.lockUsers(userId),
    { is_locked: lockValue },
    {
      headers: headersInternal,
    }
  );
};

const activateUser = async (userId, val) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.patch(
    authUrls.activateUsers(userId),
    { is_active: val },
    {
      headers: headersInternal,
    }
  );
};

const updateUser = (userId, data) => {
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
    "Content-Type": "application/json",
  };
  return axios.patch(authUrls.getUsersUrl(`${userId}/`), data, {
    headers: headersInternal,
  });
};

const sentEmailUser = (userId, ccEmail, bccEmail, mailBody) => {
  const data = new FormData();
  data.append("id", userId);
  data.append("cc", ccEmail);
  data.append("bcc", bccEmail);
  data.append("body", mailBody);
  const tokenInternal = localStorage.getItem("token");
  const headersInternal = {
    Authorization: `Bearer ${tokenInternal}`,
  };
  return axios.post(authUrls.sendEmail(userId), data, {
    headers: headersInternal,
  });
};

export default {
  refreshToken,
  loginUser,
  updatePasswordApi,
  updateProfile,
  getProfileData,
  addNewUser,
  getAlphabeticalUser,
  getNumericUser,
  deleteUser,
  lockUser,
  activateUser,
  resetUserPassword,
  sentEmailUser,
  updateUser,
};
